module.exports = __webpack_public_path__ + "img/pdf.97d1ddc9.png";